module.exports = __webpack_public_path__ + "media/images/companies/concord-bf6a640c6b34be75f8e5c16e2a0f3661.jpg";